<template>
  <WizardContent
    :graphic="{
      type: 'gradient',
      assetsPath: 'image-sales-hold',
    }"
  >
    <h4 class="mt-6 mb-9">
      <template v-if="isNewUser">
        Glad you're here, {{ firstName }}!
      </template>
      <template v-else>
        Glad you're back, {{ firstName }}!
      </template>
    </h4>
    <p class="p3 mb-6">
      <template v-if="isNewUser">
        {{ companyName || 'Your company' }}'s free trial has ended,
        but it looks like you're new to JobNav. What would you like to do?
      </template>
      <template v-else>
        {{ companyName || 'Your company' }}'s free trial has ended,
        but we're so happy you liked using JobNav. (We loved having you!)
      </template>
    </p>
    <p class="p3 mb-9">
      <template v-if="!isNewUser">
        Let's not lose all the progress you've made. What would you like to do?
      </template>
    </p>
    <p class="p3">
      <DpplAutoSizedButton
        color="textDarkest"
        :loading="isRenewLoading"
        @click="renewTrial"
      >
        <template v-if="isNewUser">
          Start a New Trial
        </template>
        <template v-else>
          Extend My Trial
        </template>
      </DpplAutoSizedButton>
    </p>
  </WizardContent>
</template>

<script>
import DpplAutoSizedButton from '@/components/datapeople/DpplAutoSizedButton.vue';
import WizardContent from '@/components/shared/WizardContent.vue';
import { mapState, mapActions } from 'pinia';
import { signupTrialRenew } from '@/api/signup';
import { useWizard } from '@/stores/wizard/wizard';
import { useModals } from '@/stores/modals/modals';
import { useAppSnackbar } from '@/stores/app/snackbar';

export default {
  name: 'TrialRenew',

  components: {
    DpplAutoSizedButton,
    WizardContent,
  },
  emits: ['track-page-load'],

  data() {
    return {
      isRenewLoading: false,
    };
  },

  computed: {
    ...mapState(useWizard, ['firstName', 'companyName', 'daysSinceJoining']),
    isNewUser() {
      return !this.daysSinceJoining || this.daysSinceJoining <= 2;
    },
  },

  beforeCreate() {
    this.$emit('track-page-load', { page: 'Trial Renew' });
  },

  methods: {
    ...mapActions(useWizard, ['updateFlash']),
    ...mapActions(useModals, ['setModal']),
    ...mapActions(useAppSnackbar, ['addInfoSnackbar']),

    async renewTrial() {
      try {
        this.isRenewLoading = true;
        const { success } = await signupTrialRenew();
        if (success) {
          this.addInfoSnackbar({
            text: `Glad you're here, ${this.firstName}.
                ${this.companyName}'s trial has successfully been extended.`,
          });
          await this.$router.replace({ name: 'root' });
        }
      } catch (e) {
        this.updateFlash({ message: e.message });
        throw e;
      } finally {
        this.isRenewLoading = false;
      }
    },
  },
};
</script>
